// src/components/employee/ProtectedEmployeeRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEmployeeAuth } from '../../hooks/useEmployeeAuth';

export default function ProtectedEmployeeRoute({ children, requiresPasswordChange = false }) {
  const { isAuthenticated, loading, employee } = useEmployeeAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" color="text.secondary">
          Loading your account...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/employee/login" replace />;
  }

  // If this route requires password change, only allow first-time logins
  if (requiresPasswordChange) {
    if (!employee?.isFirstLogin) {
      return <Navigate to="/employee/dashboard" replace />;
    }
  } else {
    // For regular routes, check if employee needs to change password
    // Only redirect if not already on change password page
    if (employee?.isFirstLogin && location.pathname !== '/employee/change-password') {
      return <Navigate to="/employee/change-password" replace />;
    }
  }

  // Pass employee data to children components
  return React.cloneElement(children, { employee });
}
